/** @format */

import {createContext} from 'react';

// Define the default state structure
const paymentsDefaultState = {
    paymentProfiles: [],
    loading: false,
    error: null
};

// Define the default context structure
const paymentsDefaultContext = {
    state: paymentsDefaultState,
    handleGetPaymentProfiles: () => {},
    removeProfileById: () => {}
};

// Create the PaymentsContext with the default values
const PaymentsContext = createContext(paymentsDefaultContext);

export {PaymentsContext, paymentsDefaultState};
